import * as actions from './user.actions';
import * as selectors from './user.selectors';
export * from './user.reducer';
export { actions, selectors };
export const featureKey = 'user';
